<template>
	<h2 class="hh2">
		<slot></slot>
	</h2>
</template>

<script>
export default {
	name: 'Hh2',
}
</script>

<style lang="scss" scoped>
.hh2 {
	margin: 28px 0 14px;
	padding: 12px 16px;
	font-size: 1.45rem;
	color: #15803d;
	font-weight: 800;
	line-height: 1.35;
	background: linear-gradient(90deg, #dcfce7 0%, #f0fdf4 55%, #ffffff 100%);
	border-left: 4px solid #16a34a;
	border-radius: 0 12px 12px 0;
	box-shadow: inset 0 -1px 0 rgba(22, 163, 74, 0.08);
}
</style>
